<template>
  <div>
    <p class="text-xl font-medium">1. Thông tin chung</p>
    <v-row class="mb-4" v-if="isUpdateMode"> </v-row>
    <v-row class="mt-0" v-if="isUpdateMode">
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="value.id"
          disabled
          outlined
          prepend-inner-icon="mdi-identifier"
          color="#FBB040"
          label="ID"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="value.roleName"
          disabled
          outlined
          prepend-inner-icon="mdi-roller-shade"
          color="#FBB040"
          label="Chức vụ"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <v-file-input
          v-model="files"
          accept="image/png, image/jpeg, image/bmp"
          placeholder="Chọn hình"
          prepend-inner-icon="mdi-camera"
          color="#FBB040"
          label="Hình đại diện"
          outlined
          @change="uploadProfile"
        ></v-file-input>
      </v-col>
      <v-col cols="12" sm="3">
        <v-avatar>
          <img :src="value.profileURL" />
        </v-avatar> </v-col
    ></v-row>
    <v-row class="mt-0">
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="value.phone"
          :rules="[rules.required]"
          outlined
          prepend-inner-icon="mdi-phone"
          color="#FBB040"
          label="Số điện thoại*"
          @keypress="filter(evt)"
          :maxLength="10"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="value.email"
          :rules="[rules.email]"
          outlined
          prepend-inner-icon="mdi-email"
          color="#FBB040"
          label="Email"
          disabled
        />
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="value.name"
          :rules="[rules.required]"
          outlined
          prepend-inner-icon="mdi-face-man"
          color="#FBB040"
          label="Họ và tên*"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <BirthdayPicker v-model="value.dateOfBirth" />
      </v-col>
      <v-col>
        <v-radio-group v-model="value.gender" row>
          <v-radio label="Nam" :value="1" color="#FBB040" />
          <v-radio label="Nữ" :value="2" color="#FBB040" />
        </v-radio-group>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="value.address"
          outlined
          prepend-inner-icon="mdi-home-city-outline"
          color="#FBB040"
          label="Địa chỉ"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { required, email } from "~/utils/validation";
import BirthdayPicker from "~/components/atoms/BirthdayPicker";
import { $toasted } from "@/plugins/vue-toast";

export default {
  name: "BasicInformation",
  components: { BirthdayPicker },
  props: {
    value: {
      type: Object,
      default: () => ({
        patientId: EMPTY,
        patientName: EMPTY,
        phone: EMPTY,
        email: null,
        gender: 1,
        dateOfBirth: EMPTY,
        provinceId: null,
        districtId: null,
        wardId: null,
        address: EMPTY,
        profilePublicId: null,
        profileURL: null,
      }),
    },
    isUpdateMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: {
        required,
        email,
      },
      files: [],
      evt: null
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true,
    },
  },
  methods: {
    uploadProfile() {
      this.$emit("image-uploading", true);
      if (this.files.size >= 5000000) {
        this.$toast.error("File ảnh quá 5MB", { position: "top-right" }).goAway(5000);
        return;
      }
      const reader = new FileReader();
      const formData = new FormData();
      formData.append("images[]", this.files);
      reader.onload = async (e) => {
        const dataURI = e.target.result;
        if (dataURI) {
          this.isLoadingActions = true;
          try {
            const data = await this.$services.userService.uploadUserImages(formData);
            if (data) {
              this.value.profilePublicId = data.data.publicId;
              this.value.profileURL = data.data.imageSecurePath;
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
          } finally {
            this.$emit("image-uploading", false);
          }
        }
      };
      reader.readAsDataURL(this.files);
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
